import {
    request,
    requestGet,
    requestMedia,
    requestPost, requestTimeOut
}
    from './request';
export default {
    listBot(data) {
        return request('/api/bot/list', data);
    },
    save(data) {
        return request('/api/bot/save', data);
    },
    update(data) {
        return request('/api/bot/update', data);
    },
    delete(data) {
        return request('/api/bot/delete/'+data.id, data);
    },
    get(data) {
        return request('/api/bot/get/'+data.id, data);
    },
	allSlave(data) {
	    return request('/api/bot/allSlave', data);
	},
	listSlave(data) {
	    return request('/api/bot/listSlave/'+data, data);
	},
	getQuestionParam(data) {
	    return request('/api/bot/getQuestionParam', data);
	},
	getHaleonSSOToken(data){
		return request('/api/sso/getToken?code='+data,data);
	},
	getUserName(data){
		return request("/api/sso/getInfo",data);
	},
	getSSOConfig(data){
		return requestGet("/api/param/get-key?key="+data,data)
	},
    getBotKnowledgeConfig(data){
        return request('/api/bot/getBotKnowledgeConfig', data);
    },
    askHaleonQuestion(data, timeout){
        return requestTimeOut('/api/haleon-chat/send-chat-message', data, timeout);
    },
}



// WEBPACK FOOTER //
// ./src/libs/axios/chatbot.js